import { Globe } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { LANGS } from "@/lib/translations";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang } = useLang();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`flex items-center gap-1.5 text-sm font-medium px-2.5 py-1.5 rounded-full border transition-colors ${dark ? "border-white/20 text-white/80 hover:border-brand-teal" : "border-brand-plum/15 text-brand-plum hover:border-brand-teal"}`}
        >
          <Globe size={15} /> {current.label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => setLang(l.code)} data-testid={`lang-option-${l.code}`} className={l.code === lang ? "text-brand-teal font-medium" : ""}>
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
